import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import {
  GuideExperience,
  guideSearchSchema,
} from "@/features/onboarding/GuideExperience";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/onboarding/guide",
)({
  validateSearch: zodValidator(guideSearchSchema),
  beforeLoad: async ({ context }) => {
    const answers =
      await context.trpcQueryUtils.account.getWelcomeAnswers.ensureData();
    if (!answers?.tools) {
      throw redirect({ to: "/onboarding/tools" });
    }
    if (!answers?.platforms) {
      throw redirect({ to: "/onboarding/platforms" });
    }
    // Funnel LinkedIn-cohort signups to the LinkedIn guide variant. The cohort
    // marker is persisted by the linkedin route the first time it's entered, so
    // it survives the tools → platforms → paywall bounce and every default-guide
    // entry (including the paywall success redirect that lands here) ends up on
    // the variant. The linkedin route only redirects to tools/platforms, never
    // back here, so there is no redirect loop.
    if (answers.cohort === "linkedin") {
      throw redirect({ to: "/onboarding/guide/linkedin" });
    }
  },
  component: () => <GuideExperience variant="default" />,
});
